__turbopack_context__.v({
  "buttonWrapper": "aSS-TW_buttonWrapper",
  "description": "aSS-TW_description",
  "grid": "aSS-TW_grid",
  "headerwrapper": "aSS-TW_headerwrapper",
  "intervention": "aSS-TW_intervention",
  "interventionSubtitle": "aSS-TW_interventionSubtitle",
  "meta": "aSS-TW_meta",
  "organization": "aSS-TW_organization",
  "organizationWrapper": "aSS-TW_organizationWrapper",
});
